import React, { useEffect, useState } from "react";
import { fetchCounter } from "@/lib/api";

export const LiveCounter = () => {
  const [count, setCount] = useState(1000);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const init = async () => {
      try {
        const data = await fetchCounter();
        if (!cancelled) {
          setCount(data.count);
          setReady(true);
        }
      } catch {
        if (!cancelled) setReady(true);
      }
    };
    init();
    // increment locally every 60s
    const tick = setInterval(() => setCount((c) => c + 1), 60_000);
    // resync every 5 minutes with server
    const resync = setInterval(async () => {
      try {
        const data = await fetchCounter();
        setCount(data.count);
      } catch {}
    }, 300_000);
    return () => {
      cancelled = true;
      clearInterval(tick);
      clearInterval(resync);
    };
  }, []);

  const digits = String(count).padStart(7, "0").split("");

  return (
    <section id="counter" className="relative py-24 md:py-32" data-testid="counter-section">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[300px] rounded-full bg-brand/10 blur-[140px]" />
      </div>
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col items-center text-center">
          <div className="chip mb-6">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full rounded-full bg-brand opacity-75 animate-ping" />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-brand" />
            </span>
            Live · Global Network
          </div>
          <h2 className="font-display text-2xl md:text-4xl font-bold tracking-tight text-white/90">
            Cards graded by <span className="logo-cursive text-brand">Blue</span>
          </h2>

          <div className="mt-10 flex items-center gap-2 md:gap-3" data-testid="counter-display" aria-live="polite">
            {digits.map((d, i) => (
              <span
                key={i}
                className={`digit-tile w-12 h-16 md:w-20 md:h-28 text-4xl md:text-6xl rounded-lg md:rounded-xl ${
                  ready ? "animate-pulse-glow" : ""
                }`}
                style={{ animationDelay: `${i * 120}ms` }}
              >
                {d}
              </span>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default LiveCounter;
